import React from "react";
import "../styles/footer.css";

export const Footer = () => {
  return <footer>Sanjeet Porfolio </footer>;
};
